import {
  LOGIN_DIR,
  QUES_PATH,
  QUES_DIR,
  APP_API_BASE_URL,
  Follow_PATH
} from "../utils/env"


const SLOW_PATH = 'https://test1.chinacaring.com/dyyy/slow/'


const PATH = APP_API_BASE_URL
var INTERFACE = {
  HISTORY: APP_API_BASE_URL + "hospital/patient/getAllHistory", //患者360
  SESSION: LOGIN_DIR + 'session',
  USER_SEARCH_NAME: LOGIN_DIR + 'user/search/name',
  USER_LIST: LOGIN_DIR + 'user/list',
  MANAGEMENT_MEDICAL_INSTITUTION: SLOW_PATH + 'management/medical_institution',
  PATIENT_H_DOCTOR: SLOW_PATH + 'patient/h_doctor',
  PATIENT_FIND: SLOW_PATH + 'patient/find',
  PATIENT: SLOW_PATH + 'patient',
  PATIENT_DETAIL: SLOW_PATH + 'patient/detail',
  PATIENT_PIN_GU_XIN_XI: SLOW_PATH + 'patient/pin_gu_xin_xi',
  UNIVERSAL_INSERT: SLOW_PATH + 'universal/insert',
  UNIVERSAL_SELECT: SLOW_PATH + 'universal/select',
  UNIVERSAL_DELETE: SLOW_PATH + 'universal/delete',
  UNIVERSAL_UPDATE: SLOW_PATH + 'universal/update',
  QUES_USE: QUES_PATH + 'questionnaire/use',
  PATIENT_HIGH_DOCTOR: SLOW_PATH + 'patient/high_doctor',
  // V2
  MANAGEMENT_REVIEW_PATIENT_15: SLOW_PATH + 'management/review_patient_15',
  MANAGEMENT_REVIEW_PATIENT: SLOW_PATH + 'management/review_patient',
  MANAGEMENT_ABNORMAL_INDEX: SLOW_PATH + 'management/abnormal_index',
  MANAGEMENT_ABNORMAL_MEDICINE: SLOW_PATH + 'management/abnormal_medicine',
  MANAGEMENT_COUNT: SLOW_PATH + 'management/count',
  MANAGEMENT_MEDICAL_INSTITUTION_LIKE: SLOW_PATH + 'management/medical_institution/like',
  MANAGEMENT_MEDICAL_TEAM: SLOW_PATH + 'management/medical_team',
  MANAGEMENT_MEDICAL_TEAM_LIKE: SLOW_PATH + 'management/medical_team/like',
  DOCTOR_H: SLOW_PATH + 'doctor/h',
  DOCTOR: SLOW_PATH + 'doctor',
  PATIENT_YI_CONG_XING: SLOW_PATH + 'patient/yi_cong_xing',
  MANAGEMENT_COMPLEX_FIND: SLOW_PATH + 'management/complex_find',
  PATIENT_JIU_ZHEN_XIN_XI: SLOW_PATH + 'patient/jiu_zhen_xin_xi',
  PATIENT_BING_QING_PING_GU: SLOW_PATH + 'patient/bing_qing_ping_gu',
  UNIVERSAL_ACT: SLOW_PATH + 'universal/act',
  UNIVERSAL_CAT: SLOW_PATH + 'universal/cat',
  UNIVERSAL_TIME_ACT: SLOW_PATH + 'universal/time/act',
  UNIVERSAL_TIME_CAT: SLOW_PATH + 'universal/time/cat',
  UNIVERSAL_ACT_JIU_ZHEN: SLOW_PATH + 'universal/act/jiu_zhen',
  UNIVERSAL_CAT_JIU_ZHEN: SLOW_PATH + 'universal/cat/jiu_zhen',



  // 筛查患者
  FILTRATE_PATIENT: SLOW_PATH + 'filtrate/patient',
  FILTRATE_PATIENT_DETAIL: SLOW_PATH + 'filtrate/patient/detail',
  FILTRATE_GROUP: SLOW_PATH + 'filtrate/group',
  FILTRATE_PATIENT_SEARCH: SLOW_PATH + 'filtrate/patient/search',
  FILTRATE_QUESTION_TYPE: SLOW_PATH + 'filtrate/questionnaire/type',
  FILTRATE_QUESTION_ADD: SLOW_PATH + 'filtrate/questionnaire/add',
  FILTRATE_QUESTION_REMOVE: SLOW_PATH + 'filtrate/questionnaire/remove',
  PATIENT_COMPLEX: SLOW_PATH + 'patient/complex',
  FILTRATE_PATIENT_UNIQUEID: SLOW_PATH + 'filtrate/patient/uniqueId',


  QUESTIONNAIRES: QUES_DIR + 'questionnaires', //获取问卷列表
  GET_QUEST: QUES_DIR + 'questionnaire', //获取问卷详情
  GET_ANSWER: QUES_DIR + 'answer', //    获取答案 提交答案 修改答案
  GET_UNIQUE_QUEST: QUES_DIR + 'extension/answer', //    获取unique
  GET_UNIQUE: QUES_DIR + 'extension/auto_unique/answer',
  QUESTIONNAIRE: QUES_DIR + 'questionnaire', //创建/删除问卷
  QUESTIONNAIRES_Template: QUES_DIR + 'template', //获取和创建和更新和删除问卷模板
  QUESTIONNAIRE_ALL: QUES_DIR + 'questionnaire/all', //一次性更新全部问卷信息
  QUESTIONNAIRES_CLASSIFICATION: QUES_DIR + 'template/classification', // 获取和创建所有分类
  SAVERULE: QUES_DIR + 'calculate/combination/save',
  GETRULE: QUES_DIR + 'calculate/combination/select',
  STATIS_QUERY: QUES_DIR + 'statistics/custom_query',
  STATIS_QUERY_VIEW: QUES_DIR + 'statistics/custom_query/over_view',
  STATIS_QUERY_MINUTE: QUES_DIR + 'statistics/custom_query/minute_num',

  TEMPLATE_ADD: QUES_DIR + 'query_template/add',
  TEMPLATE_FIND: QUES_DIR + 'query_template/find',
  TEMPLATE_FIND_PAGE: QUES_DIR + 'query_template/find_page',

  //     oliver
  MEDICINE_JILU: SLOW_PATH + 'medicine/jilu/page',
  FILTRATE_QUESTIONNAIRE_RECORD: SLOW_PATH + 'filtrate/questionnaire/record',
  FILTRATE_GROUP: SLOW_PATH + 'filtrate/group',
  FOLLOW_TYPE: Follow_PATH + '/follow_type/all_follow_type', //获取随访类型列表
  PATCHFOLLOW_TYPE: Follow_PATH + '/follow_type', //修改随访类型列表
  DELETEFOLLOW: Follow_PATH + '/follow_type?follow_type_code=', //删除随访类型列表
  FOLLOW_TYPE: Follow_PATH + '/follow_type/all_follow_type', //获取随访类型列表
  PERSON_SOURCE: Follow_PATH + '/follow_person/query_person_source', //获取对象源(通用)
  QUERY_ROOM: Follow_PATH + '/follow_person/query_room', //获取科室
  CREATE_LIST: Follow_PATH + '/follow_person/creat_list', //创建对象
  OBJECT_LIST: Follow_PATH + '/follow_person/query_follow', //对象列表
  UPDATE_LIST: Follow_PATH + '/follow_person/update_list', //修改对象
  QUERY_DETAIL: Follow_PATH + '/follow_person/query_detail', //通过id查看详情
  GETFOLLOWTYPELIST: Follow_PATH + '/follow_type/follow_type_list', //随访类型下拉列表
  GROUP_LIST: PATH + 'ehospital/classify/group', //查询分组列表
  GET_DEPARTMENT: PATH + 'follow/task_info/initiating_dept', //发起部门
  NEWS_CATEGORY: PATH + 'ehospital/news/category', //宣教分类
  CREATE_TASK_INFO: PATH + 'follow/task_info', //创建随访任务接口
  EHOSPITAL_NEWS: PATH + 'ehospital/news/category/id', //根据分类查询文章
  ADD_CATEGORY: PATH + 'ehospital/news/apply', //宣教分类

  // homeArticle
  HOME_NEWS_CATEGORY: PATH + 'ehospital/news/module/category',
  HOME_ADD_CATEGORY: PATH + 'ehospital/news/module/apply', //宣教分类
  HOME_EHOSPITAL_NEWS: PATH + 'ehospital/news/module/category/id', //根据分类查询文章

  APPLY_UPDATE: PATH + 'ehospital/news/module/apply/update',

  APPLY_UPDATE_nom: PATH + 'ehospital/news/apply/update',

  QUES_CATEGORY: PATH + 'ehospital/questionnaire/category', //问卷库分类
  QUES_NEWS: PATH + 'ehospital/questionnaire/category/id', //根据分类查询问卷
  QUES_ADD_NEW: PATH + 'ehospital/questionnaire',
  QUES_GET_NEW: PATH + 'ehospital/questionnaire/category/default',
  CATEGORYFOLLOW: PATH + 'ehospital/news/category/follow', //宣教
  QCATEGORYFOLLOW: PATH + 'ehospital/questionnaire/category/follow', //问卷
  GETTAGLIST: PATH + 'ehospital/classify/tag', //标签
  GETGROUPLIST: PATH + 'ehospital/classify/group', //分组

  TASK_LIST: Follow_PATH + '/task_info/task/list', //
  QUERY_PERSON_TYPE: Follow_PATH + '/follow_person/query_person_type',
  TO_NOT_FINISHED: Follow_PATH + '/task_info/to_not_finished', //停止执行中的任务
  TO_START: Follow_PATH + '/task_info/to_start', //激活草稿任务接口
  DELETE_TASK_INFO: Follow_PATH + '/task_info', //创建随访任务接口
  TASK_DETAIL: Follow_PATH + '/task_info/task/detail', //查询任务详情
  TASK_INFO: Follow_PATH + '/task_info/agent', //坐席执行（随访部分）接口
  PATIENT_QUERY_ROOM: Follow_PATH + '/patient/query_room', //通过用户编码获取科室信息
  QUERY_PATIENT: Follow_PATH + '/patient/query_patient', //通过随访任务编码查询患者列表
  PUSH: Follow_PATH + '/task_info/sms/questionnaire', //短信推送接口
  QUERY_BYID: Follow_PATH + '/patient/query_byid', //通过患者code查询患者详情
  UNIQUE_QUEST_ID: Follow_PATH + '/patient/query/unique_quest_id', //获取unique_quest_id




  DEPTSINFO: PATH + 'basic_info/depts',
  BUILDINGS: PATH + 'basic_info/dept/buildings',
  FLOORS: PATH + 'basic_info/dept/floors/building',
  FLOOR: PATH + 'basic_info/dept/floor',
  BUILDING: PATH + 'basic_info/dept/building',
  DEPTEDIT: PATH + 'basic_info/dept',
  HOSPITALINFO: PATH + 'basic_info/hospital_info',



  // 问卷模版库
  QUES_CATEGORY_MODULE: PATH + 'ehospital/questionnaire/moudle/category', //问卷库分类
  QUES_NEWS_MODULE: PATH + 'ehospital/questionnaire/moudle/category/id', //根据分类查询问卷
  QUES_ADD_NEW_MODULE: PATH + 'ehospital/questionnaire/moudle',

  QUES_CATEGORY_MINI: PATH + 'ehospital/questionnaire/mini/category', //问卷库分类
  QUES_NEWS_MINI: PATH + 'ehospital/questionnaire/mini/category/id', //根据分类查询问卷
  QUES_ADD_NEW_MINI: PATH + 'ehospital/questionnaire/mini',



  CONTACT_DEPTS: PATH + 'address/dept',
  CONTACT_DEPT_DOCTOR: PATH + 'address/user/dept',
  CONTACT_TAGS: PATH + 'tag',
  CONTACT_ROLES: PATH + 'role',
  CONTACT_USER: PATH + 'user',

  USER_SYNC: PATH + 'user/sync', // HIS通讯录同步
  PUBLIC_DOCTOR_SERVICE: PATH + 'public/doctor_service'








}

export {
  INTERFACE
}
